import React from "react";
import AurasSlider from "../components/Sliders/AurasSlider";
function Auras() {

  return (
    <>
      
      {/*  COLLECTIONS SLIDER (collections, pets, auras) */}
      <AurasSlider mobileApp={false}/>
      
    
    </>
  );
}

export default Auras;

